export default __webpack_public_path__ + "static/media/Blue Circle.2cb8f70b.svg";